import type { Technique } from '../types';
import { REACTION_DIFFUSION_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type ReactionDiffusionState } from './render';

export const reactionDiffusion: Technique<ReactionDiffusionState> = {
  id: 'reaction-diffusion',
  name: 'Reaction-Diffusion',
  category: 'automata',
  description: 'Gray-Scott auf der GPU, mit dem Text als Startkonzentration oder Randbedingung.',
  params: REACTION_DIFFUSION_PARAMS,
  renderer: 'webgl',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
